module.exports = __webpack_public_path__ + "static/img/asistio.12bc268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/asistio.png
// module id = 212
// module chunks = 1